import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-6 text-center" data-testid="payment-cancel-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="max-w-md">
        <p className="eyebrow mb-4">Checkout cancelled</p>
        <h1 className="font-anton uppercase text-5xl sm:text-6xl leading-none">No worries</h1>
        <p className="text-graphite mt-6">Your bag is saved. Pick up right where you left off.</p>
        <Link to="/shop" className="btn-pulse mt-10">Return to Shop</Link>
      </motion.div>
    </div>
  );
}
